const parseExpiryDate = (value) => {
    if (typeof value !== 'string') return null;
  
    const parts = value.split(/[-/]/);
    if (parts.length !== 3) return null;
  
    const [day, month, year] = parts;
    const date = new Date(`${year}-${month}-${day}`);
  
    return isNaN(date.getTime()) ? null : date;
  };
  
  const getExpiryDateFromDoc = (doc) => {
    const expiryObj = doc?.document_info?.find(
      item => item.meta_key === 'Expiry Date'
    );
  
    return parseExpiryDate(expiryObj?.meta_value);
  };
  export const filterExpiredDocTypeList = (docTypeList) => {
    const isExpired = (doc) => {
      const expiry = getExpiryDateFromDoc(doc);
      if (!expiry) return false;
  
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      expiry.setHours(0, 0, 0, 0);
  
      return expiry < today;
    };
  
    if (!Array.isArray(docTypeList)) return [];
  
    return docTypeList
      .map(docType => {
        const filteredMembers = docType.list
          .map(member => {
            const expiredDocs =
              member.document_list?.filter(doc => isExpired(doc)) || [];
  
            return {
              ...member,
              document_list: expiredDocs,
              total_document: expiredDocs.length,
            };
          })
          .filter(member => member.total_document > 0);
  
        return {
          ...docType,
          list: filteredMembers,
          total_family: filteredMembers.length,
          total_document: filteredMembers.reduce(
            (sum, m) => sum + m.total_document,
            0
          ),
        };
      })
      .filter(docType => docType.total_document > 0);
  };
  export const filterExpiredMemberList = (memberList) => {
    const isExpired = (doc) => {
      const expiry = getExpiryDateFromDoc(doc);
      if (!expiry) return false;
  
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      expiry.setHours(0, 0, 0, 0);
  
      return expiry < today;
    };
  
    if (!Array.isArray(memberList)) return [];
  
    return memberList
      .map(member => {
        const filteredDocTypes = member.list
          .map(docType => {
            const expiredDocs =
              docType.document_list?.filter(doc => isExpired(doc)) || [];
  
            return {
              ...docType,
              document_list: expiredDocs,
              total_document: expiredDocs.length,
            };
          })
          .filter(docType => docType.total_document > 0);
  
        return {
          ...member,
          list: filteredDocTypes,
          total_ducument_type: filteredDocTypes.length,
          total_document: filteredDocTypes.reduce(
            (sum, dt) => sum + dt.total_document,
            0
          ),
        };
      })
      .filter(member => member.total_document > 0);
  };
  export const filterExpiringSoonDocTypeList = (
    docTypeList,
    daysThreshold = 30
  ) => {
    const isExpiringSoon = (doc) => {
      const expiry = getExpiryDateFromDoc(doc);
      if (!expiry) return false;
  
      const today = new Date();
      const futureDate = new Date();
  
      today.setHours(0, 0, 0, 0);
      futureDate.setDate(today.getDate() + daysThreshold);
      futureDate.setHours(23, 59, 59, 999);
      expiry.setHours(0, 0, 0, 0);
  
      return expiry >= today && expiry <= futureDate;
    };
  
    if (!Array.isArray(docTypeList)) return [];
  
    return docTypeList
      .map(docType => {
        const filteredMembers = docType.list
          .map(member => {
            const expiringDocs =
              member.document_list?.filter(doc => isExpiringSoon(doc)) || [];
  
            return {
              ...member,
              document_list: expiringDocs,
              total_document: expiringDocs.length,
            };
          })
          .filter(member => member.total_document > 0);
  
        return {
          ...docType,
          list: filteredMembers,
          total_family: filteredMembers.length,
          total_document: filteredMembers.reduce(
            (sum, m) => sum + m.total_document,
            0
          ),
        };
      })
      .filter(docType => docType.total_document > 0);
  };
  export const filterExpiringSoonMemberList = (
    memberList,
    daysThreshold = 30
  ) => {
    const isExpiringSoon = (doc) => {
      const expiry = getExpiryDateFromDoc(doc);
      if (!expiry) return false;
  
      const today = new Date();
      const futureDate = new Date();
  
      today.setHours(0, 0, 0, 0);
      futureDate.setDate(today.getDate() + daysThreshold);
      futureDate.setHours(23, 59, 59, 999);
      expiry.setHours(0, 0, 0, 0);
  
      return expiry >= today && expiry <= futureDate;
    };
  
    if (!Array.isArray(memberList)) return [];
  
    return memberList
      .map(member => {
        const filteredDocTypes = member.list
          .map(docType => {
            const expiringDocs =
              docType.document_list?.filter(doc => isExpiringSoon(doc)) || [];
  
            return {
              ...docType,
              document_list: expiringDocs,
              total_document: expiringDocs.length,
            };
          })
          .filter(docType => docType.total_document > 0);
  
        return {
          ...member,
          list: filteredDocTypes,
          total_ducument_type: filteredDocTypes.length,
          total_document: filteredDocTypes.reduce(
            (sum, dt) => sum + dt.total_document,
            0
          ),
        };
      })
      .filter(member => member.total_document > 0);
  };
          